// extracted by mini-css-extract-plugin
export default {"outerDiv":"verticals-page_outerDiv__znslC","card-grid-verticals":"verticals-page_card-grid-verticals__sLIoa","headerText":"verticals-page_headerText__xOzAq"};